module.exports = __webpack_public_path__ + "img/flourish-coin-darker.b0c2dfe7.svg";